import gql from "@/api/gql"

const components = gql`
	query components($where: componentWhereInput, $limit: Int, $skip: Int, $sort: sortInput) {
		components(where: $where, limit: $limit, skip: $skip, sort: $sort) {
			list {
				id
				name
				vueTemplate
				status
				version {
					framework
					version
				}
			}
		}
	}
`

const createComponent = gql`
	mutation createComponent($input: createComponentInput!) {
		createComponent(input: $input) {
			status
			createdStatus {
				id
			}
			errors
		}
	}
`

const updateComponent = gql`
	mutation updateComponent($id: String!, $input: updateComponentInput!) {
		updateComponent(id: $id, input: $input) {
			status
			errors
		}
	}
`

const deleteComponent = gql`
	mutation deleteComponent($id: String!) {
		deleteComponent(id: $id) {
			status
			errors
		}
	}
`

const cmsConfig = gql`
	query cmsConfig($where: CmsConfigWhereInputGraphType) {
		cmsConfigs(where: $where) {
			baseComponentsVariantsJsonString
			themeJsonString
			endpointsJsonString
			componentRoutes {
				component
				metaJsonString
				name
				path
				propsJsonString
				redirect
			}
		}
	}
`

const upsertCmsConfig = gql`
	mutation upsertCmsConfig($appId: String!, $config: cmsConfigInput!) {
		upsertCmsConfig(appId: $appId, config: $config) {
			status
			errors
		}
	}
`

export const query = {
	components,
	cmsConfig
}

export const mutation = { createComponent, updateComponent, deleteComponent, upsertCmsConfig }
